import type { PartialTranslation } from "./index";

/** Vietnamese — see `../../vi/index.ts` for the terminology notes. */
export const home: PartialTranslation["home"] = {
  welcome: {
    title: "Chào mừng đến với Lyder Talk",
    subtitle: "Không gian luyện tập hằng ngày để bạn nói tự tin hơn.",
    featOneTitle: "Luyện nói",
    featOneDesc: "Chọn một chủ đề, tạo câu hỏi và luyện nói to kèm phản hồi tức thì.",
    featTwoTitle: "Xây dựng chuỗi ngày",
    featTwoDesc: "Luyện tập mỗi ngày để giữ chuỗi ngày, tích XP và thăng cấp.",
    featThreeTitle: "Theo dõi tiến độ",
    featThreeDesc: "Lưu từ vựng, ôn tập theo khoảng cách và leo lên bảng xếp hạng.",
    maybeLater: "Để sau",
    startTour: "Bắt đầu tham quan",
  },
  hero: {
    welcomeTitle: "Chào mừng đến với Lyder Talk",
    description: "Chọn một chủ đề, luyện nói và xây dựng chuỗi ngày mỗi ngày.",
    createTopic: "Tạo chủ đề",
    browseTopics: "Khám phá chủ đề",
    randomQuestion: "Roll & Talk",
    greeting: {
      lateNight: "Thức khuya rồi",
      morning: "Chào buổi sáng",
      afternoon: "Chào buổi chiều",
      evening: "Chào buổi tối",
      night: "Chào mừng trở lại",
    },
    guestName: "bạn",
    defaultName: "bạn",
  },
  today: {
    label: "Hôm nay",
    dueForReview: "Đến hạn ôn tập",
    wordsReady_other: "từ sẵn sàng",
    streak: "Chuỗi ngày",
    day_other: "ngày",
    weeklyXp: "XP tuần này",
    weeklyXpAria: "Tiến độ XP tuần này",
    ctaReview_other: "Ôn tập {{count}} từ",
    ctaStartStreak: "Bắt đầu luyện tập hôm nay",
    ctaKeepPractising: "Tiếp tục luyện tập",
    startStreakHint: "Khởi đầu một chuỗi ngày bền vững",
    aboutMinutes: "khoảng {{count}} phút",
  },
  continue: {
    title: "Tiếp tục luyện tập",
    empty: "Chưa có gì đang dở",
    emptyDescription: "Chọn một chủ đề, tiến độ của bạn sẽ hiện ở đây.",
    browse: "Khám phá chủ đề",
    practised: "Bạn đã luyện tập",
    studied: "Bạn đã học",
    created: "Bạn đã tạo",
    lastStudied: "Học gần nhất {{when}}",
    lastPractised: "Luyện tập gần nhất {{when}}",
  },
  discover: {
    trending: "Thịnh hành",
    new: "Mới",
    trendingTitle: "Phổ biến tuần này",
    newTitle: "Mới từ cộng đồng",
    collections: "Bộ sưu tập",
    collectionsTitle: "Bộ sưu tập chọn lọc",
    empty: "Chưa có chủ đề nào ở đây",
    unknownTopic: "Chủ đề không xác định",
  },
  topicOfDay: {
    title: "Chủ đề trong ngày",
    curatedDaily: "Chọn lọc hằng ngày",
    openEnded: "Hội thoại tự do",
    practise: "Luyện tập",
    view: "Xem",
  },
  quote: {
    label: "Trích dẫn hôm nay",
    loading: "Đang tải trích dẫn hôm nay",
  },
  emptyState: {
    eyebrow: "Bắt đầu",
    title: "Bắt đầu luyện nói trong 3 bước",
    titleAuthenticated: "Bảng điều khiển của bạn đã sẵn sàng",
    description:
      "Tạo tài khoản, chọn một chủ đề và bắt đầu phiên luyện nói 5 phút. Không cần thẻ thanh toán.",
    descriptionAuthenticated:
      "Chọn một chủ đề bên dưới để bắt đầu phiên đầu tiên. Chúng tôi sẽ theo dõi tiến độ và xây dựng chuỗi ngày từ đó.",
    stepLabel: "Bước {{step}}",
    cta: "Khám phá chủ đề",
    quickPractice: "Luyện nhanh",
    getStartedFree: "Bắt đầu miễn phí",
    steps: {
      browse: "Khám phá chủ đề",
      browseDescription: "Hàng trăm chủ đề chọn lọc về kinh doanh, du lịch, phong cách sống và nhiều hơn nữa.",
      pick: "Chọn một chủ đề",
      pickDescription: "Lọc theo chuyên mục, trình độ hoặc độ phổ biến. Lưu chủ đề yêu thích vào thư viện.",
      practise: "Luyện nói",
      practiseDescription: "Ghi âm bạn trả lời câu hỏi. Xây dựng chuỗi ngày và theo dõi tiến độ theo thời gian.",
    },
  },
  studyingNow: {
    label: "Đang luyện tập",
    live: "Trực tiếp",
    learners_other: "{{total}} người đang luyện tập",
    topicLearners_other: "{{count}} người",
    subjects_other: "{{total}} chủ đề",
    join: "Vào phòng",
    moreRooms_other: "+{{count}} phòng",
    anonymousTopic: "Đang luyện tập",
    learnersShort_other: "{{total}} người",
    moreSubjects_other: "+{{count}} chủ đề",
    showLess: "Thu gọn",
  },
  loginPrompt: {
    title: "Đăng nhập để lưu tiến độ",
    description: "Chuỗi ngày, từ vựng và các bản ghi của bạn đi theo tài khoản.",
    cta: "Đăng nhập",
    secondary: "Xem như khách",
  },
  };
